import React from "react";
import { Loader2 } from "lucide-react";

export default function Loader({ full, label = "Loading…" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${full ? "min-h-screen" : "py-16"}`} data-testid="loader">
      <Loader2 className="w-10 h-10 text-thali-green animate-spin" />
      <span className="text-thali-ink/60 font-heading">{label}</span>
    </div>
  );
}
